__turbopack_context__.v({
  "accordion": "Product-module-scss-module__v52XMW__accordion",
  "award": "Product-module-scss-module__v52XMW__award",
  "awardAsset": "Product-module-scss-module__v52XMW__awardAsset",
  "awardWrapper": "Product-module-scss-module__v52XMW__awardWrapper",
  "blocks": "Product-module-scss-module__v52XMW__blocks",
  "content": "Product-module-scss-module__v52XMW__content",
  "cta": "Product-module-scss-module__v52XMW__cta",
  "ctaButtons": "Product-module-scss-module__v52XMW__ctaButtons",
  "discontinued": "Product-module-scss-module__v52XMW__discontinued",
  "eyebrow": "Product-module-scss-module__v52XMW__eyebrow",
  "fade-in": "Product-module-scss-module__v52XMW__fade-in",
  "hasAward": "Product-module-scss-module__v52XMW__hasAward",
  "header": "Product-module-scss-module__v52XMW__header",
  "header--dark-text": "Product-module-scss-module__v52XMW__header--dark-text",
  "headerInner": "Product-module-scss-module__v52XMW__headerInner",
  "icon": "Product-module-scss-module__v52XMW__icon",
  "iconPlacement": "Product-module-scss-module__v52XMW__iconPlacement",
  "image": "Product-module-scss-module__v52XMW__image",
  "imageContainer": "Product-module-scss-module__v52XMW__imageContainer",
  "imageInner": "Product-module-scss-module__v52XMW__imageInner",
  "imageShadow": "Product-module-scss-module__v52XMW__imageShadow",
  "productImage": "Product-module-scss-module__v52XMW__productImage",
  "productPage": "Product-module-scss-module__v52XMW__productPage",
  "productVariant": "Product-module-scss-module__v52XMW__productVariant",
  "productVariant--selected": "Product-module-scss-module__v52XMW__productVariant--selected",
  "productVariantIconChecked": "Product-module-scss-module__v52XMW__productVariantIconChecked",
  "productVariant__title": "Product-module-scss-module__v52XMW__productVariant__title",
  "productVariants": "Product-module-scss-module__v52XMW__productVariants",
  "productVariantsContainer": "Product-module-scss-module__v52XMW__productVariantsContainer",
  "scale-in-check": "Product-module-scss-module__v52XMW__scale-in-check",
  "theme--makers-reserve": "Product-module-scss-module__v52XMW__theme--makers-reserve",
  "title": "Product-module-scss-module__v52XMW__title",
  "titleContainer": "Product-module-scss-module__v52XMW__titleContainer",
  "weights": "Product-module-scss-module__v52XMW__weights",
});
